import {
  Card,
  CardContent,
  CardHeader,
  Skeleton,
  SkeletonProps,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import * as React from "react";

import { ApiError } from "types/ApiErrors";

const useStyles = makeStyles((theme) => ({
  skeleton: {
    borderRadius: theme.shape.borderRadius,
  },
  root: {
    transform: "none",
  },
}));

export const SkeletonLoader: React.FC<
  SkeletonProps & { loading: boolean; error?: ApiError }
> = ({
  loading,
  children,
  animation = "wave",
  width = "100%",
  error,
  ...props
}) => {
  const classes = useStyles();

  if (error) {
    return (
      <Card sx={props.sx} data-testid="error-state">
        <CardHeader title={error.code} />
        <CardContent>
          <Typography variant="body2">{error.message}</Typography>
        </CardContent>
      </Card>
    );
  }

  if (loading) {
    return (
      <Skeleton
        data-testid="loading-state"
        width={width}
        animation={animation}
        className={classes.skeleton}
        classes={{
          root: classes.root,
        }}
        {...props}
      >
        {children}
      </Skeleton>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
